var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckGreen3X(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check_green@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check_green",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    transform: "translate(2.000000, 2.000000)",
    fill: "#42731D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,10.5 C8.03756612,10.5 10.5,8.03756612 10.5,5 C10.5,1.96243388 8.03756612,-0.5 5,-0.5 C1.96243388,-0.5 -0.5,1.96243388 -0.5,5 C-0.5,8.03756612 1.96243388,10.5 5,10.5 Z M5,9.5 C2.51471863,9.5 0.5,7.48528137 0.5,5 C0.5,2.51471863 2.51471863,0.5 5,0.5 C7.48528137,0.5 9.5,2.51471863 9.5,5 C9.5,7.48528137 7.48528137,9.5 5,9.5 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.81225216,4.65865414 C2.62373204,4.45687511 2.30733207,4.44612663 2.10555304,4.63464674 C1.903774,4.82316685 1.89302552,5.13956682 2.08154563,5.34134586 L3.55772366,6.92134586 C3.7508537,7.12805905 4.07687001,7.13351354 4.27680696,6.93337666 L7.35373003,3.85337666 C7.54889457,3.65801695 7.54873636,3.3414345 7.35337666,3.14626997 C7.15801695,2.95110543 6.8414345,2.95126364 6.64626997,3.14662334 L3.93511487,5.86048959 L2.81225216,4.65865414 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen3X);
export default __webpack_public_path__ + "static/media/check_green@3x.71b87ee095a477e1bb095869e8bdf1fd.svg";
export { ForwardRef as ReactComponent };